<script setup>
import { ref, watch } from 'vue'
import { router } from '@inertiajs/vue3'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: 'Buscar...'
  },
  url: {
    type: String,
    default: ''
  },
  params: {
    type: Object,
    default: () => ({})
  },
  debounceTime: {
    type: Number,
    default: 250
  },
  // Permite especificar qué datos preservar
  only: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])

const input = ref(null)
const searchValue = ref(props.modelValue)
const debounce = ref(null)

watch(
  () => searchValue.value,
  (value) => {
    emit('update:modelValue', value)

    if (props.url) {
      clearTimeout(debounce.value)

      debounce.value = setTimeout(() => {
        const params = { ...props.params, search: value }
        const routerOptions = { 
          preserveScroll: true, 
          replace: true,
          preserveState: true
        }
        
        // Si se especificaron propiedades para preservar, las incluimos
        if (props.only && props.only.length > 0) {
          routerOptions.only = props.only
        }
        
        router.get(props.url, params, routerOptions)
      }, props.debounceTime)
    }
  }
)

function focus() {
  input.value.focus()
}

function clearSearch() {
  searchValue.value = ''
  input.value.focus()
}

defineExpose({ focus })
</script>

<template>
  <div class="relative group">
    <div
      class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none transition-colors duration-200 group-hover:text-indigo-500"
    >
      <svg
        class="w-4 h-4 text-gray-400 group-hover:text-indigo-500"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <input
      ref="input"
      v-model="searchValue"
      class="py-2.5 pl-10 pr-4 w-full bg-white border border-gray-300 text-gray-700 rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 hover:border-indigo-300"
      :placeholder="placeholder"
      type="text"
    />
    <button
      v-if="searchValue"
      type="button"
      class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
      @click="clearSearch"
    >
      <svg
        class="w-4 h-4"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </button>
  </div>
</template>
